@use '../../styles/base/_include-media' as media;
@use '../../ui-library/styles/layout' as layout;
@use '../../ui-library/styles/surface' as surface;

.contentWrapper {
  height: calc(100vh - #{layout.$header-height});
  padding: 24px 15px 34px;
  position: relative;
  width: 100%;
  display: flex;
  flex-grow: 1;
  transition: all 0.2s;
  overflow-y: auto;
  overflow-x: hidden;

  &.collapsed {
    height: calc(100vh - #{layout.$header-height});
  }

  &.noScroll {
    overflow: hidden;
  }
  &.greyBackgroundColor {
    background-color: surface.$surface-default;
  }
}

.contentWrapperContainer {
  max-width: 930px;
  width: 100%;
  margin: 0 auto;
  position: relative;

  &.vAlignMiddle {
    @include media.media('>=tablet') {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  &.columnDirection {
    display: flex;
    flex-direction: column;
  }
}

.drawerWrapper {
  display: flex;

  &.open {
    display: flex;

    .contentWrapper {
      padding-right: layout.$drawer-width-sm;

      @include media.media('>=widescreen') {
        padding-right: layout.$drawer-width;
      }
    }
  }
}
